export default __webpack_public_path__ + "media/Dairy-Milk.2c03be28.png";